/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
import moment = require('moment');
import Moment = moment.Moment;
import {Model, ModelMixin} from '../common/model.class';
import _ = require('lodash');

//region Other Classes
export class Signature {

    data: string;
    date: Moment;
    ip: string;

    constructor(jsonData: any = {}) {
        if (jsonData.date) jsonData.date = moment(jsonData.date);
        Object.assign(this, jsonData);
    }
}
//endregion

export class ReleaseAuthorization extends ModelMixin() implements Model<ReleaseAuthorization> {

    TYPE = ReleaseAuthorization;

    electronicSignature: Signature = new Signature();

    constructor(jsonData: any = {}) {
        super();
        jsonData.electronicSignature = jsonData.electronicSignature && !_.isEmpty(jsonData.electronicSignature) ? new Signature(jsonData.electronicSignature) : undefined;
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/release/release-authorization.model.ts